import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IrisButtonTypes, IrisButtonIconPositions, IrisButtonModule } from '@sondermind/iris/button';
import { IconColors, IconSizes, IrisIconComponent } from '@sondermind/iris/icon';
import { IrisButtonTarget } from '@sondermind/iris/shared';
import { APP_STORE_URLS } from '@sondermind/constants';

@Component({
  selector: 'app-download-app-banner',
  standalone: true,
  imports: [
    CommonModule,
    IrisButtonModule,
    IrisIconComponent
  ],
  templateUrl: './download-app-banner.component.html',
  styleUrls: ['./download-app-banner.component.scss']
})
export class DownloadAppBannerComponent {
  buttonTypes = IrisButtonTypes;
  iconPositions = IrisButtonIconPositions;
  iconSizes = IconSizes;
  iconColors = IconColors;
  target = IrisButtonTarget;
  downloadAppLink = APP_STORE_URLS.onelink;
}
